"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _index = require("../../constants/index.js");

var _index2 = require("../../helpers/index.js");

var _excluded = ["sku", "name", "priceTotal", "quantity", "productName", "category", "soc", "listPrice", "paymentAmount", "shipping", "discount", "taxAmount", "contractLength", "deviceConfiguration", "deviceTradeInManufacturer", "deviceStorage", "discountType", "paymentType", "prodDataAmount", "prodLanguage", "productBrand", "productColour", "productGenre", "productProvisioner", "productSize", "productType", "servicePayment", "serviceTier", "shipToHome", "shippingMethod", "subCategory"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var booleanTypes = _index.eventFieldValues.booleanTypes;
var stringField = _index2.formatters.stringField;

var getTemplate = function getTemplate(_ref) {
  var sku = _ref.sku,
      name = _ref.name,
      priceTotal = _ref.priceTotal,
      quantity = _ref.quantity,
      productName = _ref.productName,
      category = _ref.category,
      soc = _ref.soc,
      listPrice = _ref.listPrice,
      paymentAmount = _ref.paymentAmount,
      shipping = _ref.shipping,
      discount = _ref.discount,
      taxAmount = _ref.taxAmount,
      contractLength = _ref.contractLength,
      deviceConfiguration = _ref.deviceConfiguration,
      deviceTradeInManufacturer = _ref.deviceTradeInManufacturer,
      deviceStorage = _ref.deviceStorage,
      discountType = _ref.discountType,
      paymentType = _ref.paymentType,
      prodDataAmount = _ref.prodDataAmount,
      prodLanguage = _ref.prodLanguage,
      productBrand = _ref.productBrand,
      productColour = _ref.productColour,
      productGenre = _ref.productGenre,
      productProvisioner = _ref.productProvisioner,
      productSize = _ref.productSize,
      productType = _ref.productType,
      servicePayment = _ref.servicePayment,
      serviceTier = _ref.serviceTier,
      shipToHome = _ref.shipToHome,
      shippingMethod = _ref.shippingMethod,
      subCategory = _ref.subCategory,
      rest = _objectWithoutProperties(_ref, _excluded);

  var conditionalProperties = {};
  if (typeof shipToHome === 'boolean') conditionalProperties.shipToHome = shipToHome ? booleanTypes.YES : booleanTypes.NO;
  return {
    SKU: sku,
    name: stringField(name),
    priceTotal: priceTotal,
    quantity: quantity,
    _telus: _objectSpread(_objectSpread({
      productName: stringField(productName),
      category: stringField(category),
      soc: stringField(soc),
      listPrice: {
        amount: listPrice
      },
      paymentAmount: {
        amount: paymentAmount
      },
      shipping: {
        amount: shipping
      },
      discount: {
        amount: discount
      },
      taxAmount: {
        amount: taxAmount
      },
      contractLength: contractLength,
      deviceConfiguration: stringField(deviceConfiguration),
      deviceTradeInManufacturer: stringField(deviceTradeInManufacturer),
      deviceStorage: stringField(deviceStorage),
      discountType: stringField(discountType),
      paymentType: stringField(paymentType),
      prodDataAmount: stringField(prodDataAmount),
      prodLanguage: stringField(prodLanguage),
      productBrand: stringField(productBrand),
      productColour: stringField(productColour),
      productGenre: stringField(productGenre),
      productProvisioner: stringField(productProvisioner),
      productSize: stringField(productSize),
      productType: stringField(productType),
      servicePayment: stringField(servicePayment),
      serviceTier: stringField(serviceTier),
      shippingMethod: stringField(shippingMethod),
      subCategory: stringField(subCategory)
    }, conditionalProperties), rest)
  };
};

var _default = getTemplate;
exports["default"] = _default;